export default "__VITE_ASSET__92VigdqR__"